import { useState } from "react";
import { Stepper } from "../Stepper/Stepper";
import s from "./style.module.scss";
import { UIButton } from "../UIButton/UIButton";
import step1 from "./../../assets/step1.webp";
import step2 from "./../../assets/step2.webp";
import step3 from "./../../assets/step3.webp";

import step1Dark from "./../../assets/step1dark.webp";
import step2Dark from "./../../assets/step2dark.webp";
import step3Dark from "./../../assets/step3dark.webp";
import clsx from "clsx";
import { useNavigate } from "react-router";
import useTheme from "@/core/hooks/useTheme";

const steps = [
  {
    title: "Услуга под любой запрос",
    description: "На FL более 2 000 фриланс-услуг любой категории",
  },
  {
    title: "Удобные способы оплаты",
    description: "Оплачивайте не выходя из приложения",
  },
  {
    title: "Простая коммуникация с фрилансером",
    description: "Узнавайте, как идет процесс выполнения задачи",
  },
];

export const OnBoarding = () => {
  const [step, setSteps] = useState(0);
  const images = {
    dark: [step1Dark, step2Dark, step3Dark],
    light: [step1, step2, step3],
  };
  const navigate = useNavigate();
  const handleNext = () => {
    if (step === 2) {
      navigate("/", { replace: true });
    } else {
      setSteps((prev) => prev + 1);
    }
  };

  const theme = useTheme();

  return (
    <div className={s.onBoarding}>
      {step === 0 && (
        <img src={images[theme][step]} alt="" className={clsx(s.image)} />
      )}
      {step === 1 && (
        <img
          src={images[theme][step]}
          alt=""
          className={clsx(s.image, s.secondImage)}
        />
      )}
      {step === 2 && (
        <img
          src={images[theme][step]}
          alt=""
          className={clsx(s.image, s.thirdImage)}
        />
      )}
      {/* <img
        src={images[step]}
        alt=""
        className={clsx(
          s.image,
          step === 2 && s.thirdStep,
          step === 1 && s.secondStep
        )}
      /> */}

      <div className={s.text}>
        <p className={s.title}>{steps[step].title}</p>
        <p className={s.description}>{steps[step].description}</p>
      </div>
      <Stepper step={step} />
      <div className={s.buttons}>
        <UIButton
          fontType={"primary-2"}
          className={s.button}
          onClick={handleNext}
        >
          Далее
        </UIButton>
        <UIButton
          fontType={"primary-2"}
          color="inverted"
          className={s.button}
          onClick={() => navigate("/", { replace: true })}
        >
          Пропустить
        </UIButton>
      </div>
    </div>
  );
};
